// stringLowerCaseFirstLetter
//

export default (string) => {
  if (!string) return '';
  return string[0].toLowerCase() + string.substring(1);
};
